import { Bank, Coins, DownloadSimple } from "@phosphor-icons/react";
import { Reveal, ChapterTag } from "./Reveal";

const STEPS = [
  {
    number: "01",
    icon: DownloadSimple,
    title: "Download the App",
    copy: "Get the Coin Adda Android app from this page and create your account in minutes.",
    testId: "step-download",
  },
  {
    number: "02",
    icon: Coins,
    title: "Deposit USDT",
    copy: "Transfer USDT to your personal deposit address shown inside the app.",
    testId: "step-deposit",
  },
  {
    number: "03",
    icon: Bank,
    title: "Receive INR",
    copy: "Place your exchange and receive INR directly in your bank account.",
    testId: "step-receive",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative border-t border-white/5 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="02" label="Process" />
          <h2 className="mt-6 max-w-2xl font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl">
            Three Steps. <span className="text-[#00F5A0]">That's It.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.12}>
              <div
                data-testid={step.testId}
                className="group relative h-full overflow-hidden rounded-[1.75rem] border border-white/10 bg-[#0F172A]/60 p-8 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-[#00F5A0]/40 sm:p-10"
              >
                <span className="font-display text-7xl font-extrabold tracking-tighter text-white/5 transition-colors duration-500 group-hover:text-[#00F5A0]/15 sm:text-8xl">
                  {step.number}
                </span>
                <step.icon
                  size={34}
                  weight="duotone"
                  className="mt-6 text-[#00F5A0]"
                />
                <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-slate-50 sm:text-2xl">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {step.copy}
                </p>
                {i < STEPS.length - 1 && (
                  <span aria-hidden className="absolute right-6 top-8 hidden font-mono text-xs tracking-[0.3em] text-slate-600 md:block">
                    →
                  </span>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
